module.exports = __webpack_public_path__ + "assets/img/u5e706f62d1faf.c31c90f3.png";